import { render, staticRenderFns } from "./TagCategoryTemplateImportModal.vue?vue&type=template&id=6fb62e9a"
import script from "./TagCategoryTemplateImportModal.vue?vue&type=script&lang=js"
export * from "./TagCategoryTemplateImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports